import { StyledInfoAlert } from "./alert.styled";
import { Box, palette, Stack, Typography } from "@mzc-pdc/ui";
import { IconInfoCircle } from "@mzc-cloudplex/icons";

/**
 * @param {object} params
 * @param {string} [params.role] 지정하지 않으면 MUI Alert 기본값(`alert`)을 그대로 쓴다.
 *        긴급 알림이 아니라 상태 설명인 경우 `status` 를 넘겨야 스크린리더 낭독을 가로채지 않는다.
 */
const InfoAlert = ({ content, iconSize = 16, role }) => {
    if (!content) return null;
    return (
        <StyledInfoAlert
            severity={"info"}
            color={"info"}
            variant={"outlined"}
            icon={<IconInfoCircle size={iconSize} htmlColor={palette.info[700]} />}
            size={iconSize}
            {...(role && { role })}
        >
            <Stack container direction={"column"} spacing={1}>
                {content.title && (
                    <Typography variant={"body1_500"} color={palette.greySecondary[800]}>
                        {content.title}
                    </Typography>
                )}
                {content.data?.length > 0 && (
                    <Typography variant={"body1_400"} color={palette.greySecondary[800]} gap={1}>
                        {content.data?.map((item) => (
                            <>
                                {item.subTitle && <Box component={"span"}>{item.subTitle}</Box>}
                                {item.section}
                            </>
                        ))}
                    </Typography>
                )}
            </Stack>
        </StyledInfoAlert>
    );
};

export default InfoAlert;
